import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/pera.png'


const _hoisted_1 = { class: "cl-sidebar__brand" }
const _hoisted_2 = {
  key: 0,
  class: "cl-sidebar__logo"
}
const _hoisted_3 = { class: "cl-sidebar__logo-text" }
const _hoisted_4 = {
  key: 0,
  class: "badge bg-info rounded-pill ms-1 cl-host-badge"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_0,
  alt: "Clementine",
  class: "cl-sidebar__logo-img"
}
const _hoisted_6 = { class: "cl-sidebar__nav" }
const _hoisted_7 = { class: "cl-nav" }
const _hoisted_8 = { class: "cl-nav__item" }
const _hoisted_9 = { class: "cl-nav__label" }
const _hoisted_10 = {
  key: 0,
  class: "cl-nav__item"
}
const _hoisted_11 = { class: "cl-nav__label" }
const _hoisted_12 = {
  key: 1,
  class: "cl-nav__item"
}
const _hoisted_13 = ["title", "onClick"]
const _hoisted_14 = { class: "cl-nav__label" }
const _hoisted_15 = { class: "cl-nav cl-nav--children" }
const _hoisted_16 = {
  key: 0,
  class: "cl-nav__item"
}
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "cl-nav__label" }
const _hoisted_19 = {
  key: 1,
  class: "cl-nav__item"
}
const _hoisted_20 = { class: "cl-nav__label" }
const _hoisted_21 = {
  key: 2,
  class: "cl-nav__item"
}
const _hoisted_22 = ["title", "onClick"]
const _hoisted_23 = { class: "cl-nav__label" }
const _hoisted_24 = { class: "cl-nav cl-nav--grandchildren" }
const _hoisted_25 = { class: "cl-nav__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_ChangePasswordComponent = _resolveComponent("ChangePasswordComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LoaderComponent),
    _createVNode(_component_ChangePasswordComponent),
    _createElementVNode("aside", {
      class: _normalizeClass(["cl-sidebar", { 'cl-sidebar--collapsed': _ctx.collapsed }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.collapsed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createElementVNode("img", {
                src: _imports_0,
                alt: "Clementine",
                class: "cl-sidebar__logo-img"
              }, null, -1)),
              _createElementVNode("span", _hoisted_3, [
                _cache[0] || (_cache[0] = _createTextVNode(" Clementine ", -1)),
                (_ctx.isHost())
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('host')), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("img", _hoisted_5))
      ]),
      _createElementVNode("nav", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: "/home",
              class: _normalizeClass(["cl-nav__link", { 'cl-nav__link--active': _ctx.$route.path === '/home' }]),
              title: _ctx.$t(_ctx.buildKey('Home'))
            }, {
              default: _withCtx(() => [
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-home cl-nav__icon" }, null, -1)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(_ctx.buildKey('Home'))), 1)
              ]),
              _: 1
            }, 8, ["class", "title"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (page, idx) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
              (_ctx.hasNotChild(page))
                ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                    _createVNode(_component_router_link, {
                      to: page.pageUrl,
                      class: _normalizeClass(["cl-nav__link", { 'cl-nav__link--active': _ctx.hasActive(page, _ctx.$route.path) }]),
                      title: _ctx.$t(_ctx.buildKey(page.pageName))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", {
                          class: _normalizeClass([_ctx.makeIcon(page), "cl-nav__icon"])
                        }, null, 2),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t(_ctx.buildKey(page.pageName))), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "class", "title"])
                  ]))
                : (_openBlock(), _createElementBlock("li", _hoisted_12, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["cl-nav__link cl-nav__link--btn w-100", { 'cl-nav__link--active': _ctx.isGroupActive(page, _ctx.$route.path) }]),
                      title: _ctx.$t(_ctx.buildKey(page.pageName)),
                      onClick: ($event: any) => (_ctx.onParentGroupClick(idx))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass([_ctx.makeIcon(page), "cl-nav__icon"])
                      }, null, 2),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t(_ctx.buildKey(page.pageName))), 1),
                      _createElementVNode("i", {
                        class: _normalizeClass(["fas cl-nav__chevron", _ctx.openGroups.includes(idx) ? 'fa-angle-left' : 'fa-angle-right'])
                      }, null, 2)
                    ], 10, _hoisted_13),
                    _withDirectives(_createElementVNode("ul", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.childs, (child, cidx) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: cidx }, [
                          (_ctx.hasNotChildPageURL(child))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                                _createElementVNode("span", {
                                  class: "cl-nav__link cl-nav__link--child cl-nav__link--disabled",
                                  title: _ctx.$t(_ctx.buildKey(child.pageName))
                                }, [
                                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "cl-nav__bullet" }, "•", -1)),
                                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t(_ctx.buildKey(child.pageName))), 1)
                                ], 8, _hoisted_17)
                              ]))
                            : (_ctx.hasPageURLNotChild(child))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                                  _createVNode(_component_router_link, {
                                    to: child.pageUrl,
                                    class: _normalizeClass(["cl-nav__link cl-nav__link--child", { 'cl-nav__link--active': _ctx.hasActive(child, _ctx.$route.path) }]),
                                    title: _ctx.$t(_ctx.buildKey(child.pageName))
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "cl-nav__bullet" }, "•", -1)),
                                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t(_ctx.buildKey(child.pageName))), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to", "class", "title"])
                                ]))
                              : (_openBlock(), _createElementBlock("li", _hoisted_21, [
                                  _createElementVNode("button", {
                                    class: _normalizeClass(["cl-nav__link cl-nav__link--child cl-nav__link--btn w-100", { 'cl-nav__link--active': _ctx.isGroupActive(child, _ctx.$route.path) }]),
                                    title: _ctx.$t(_ctx.buildKey(child.pageName)),
                                    onClick: ($event: any) => (_ctx.toggleGroup(`${idx}-${cidx}`))
                                  }, [
                                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "cl-nav__bullet" }, "•", -1)),
                                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t(_ctx.buildKey(child.pageName))), 1),
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["fas cl-nav__chevron", _ctx.openGroups.includes(`${idx}-${cidx}`) ? 'fa-angle-left' : 'fa-angle-right'])
                                    }, null, 2)
                                  ], 10, _hoisted_22),
                                  _withDirectives(_createElementVNode("ul", _hoisted_24, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.childs, (grand, gidx) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: gidx,
                                        class: "cl-nav__item"
                                      }, [
                                        _createVNode(_component_router_link, {
                                          to: grand.pageUrl,
                                          class: _normalizeClass(["cl-nav__link cl-nav__link--grand", { 'cl-nav__link--active': _ctx.hasActive(grand, _ctx.$route.path) }]),
                                          title: _ctx.$t(_ctx.buildKey(grand.pageName))
                                        }, {
                                          default: _withCtx(() => [
                                            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "cl-nav__bullet cl-nav__bullet--sm" }, "›", -1)),
                                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t(_ctx.buildKey(grand.pageName))), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to", "class", "title"])
                                      ]))
                                    }), 128))
                                  ], 512), [
                                    [_vShow, _ctx.openGroups.includes(`${idx}-${cidx}`)]
                                  ])
                                ]))
                        ], 64))
                      }), 128))
                    ], 512), [
                      [_vShow, _ctx.openGroups.includes(idx)]
                    ])
                  ]))
            ], 64))
          }), 128))
        ])
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "cl-sidebar__footer" }, [
        _createTextVNode(" Copyright ©"),
        _createElementVNode("a", { href: "#" }, "Numberskills"),
        _createTextVNode(". All rights reserved. ")
      ], -1))
    ], 2)
  ], 64))
}